import { ConfirmModal, Toasts, useModalContext } from '@fourthwall/components';
import { routing } from '@utils/routing';
import logoSrc from '../../../assets/signets/mailchimp.svg';
import { useAppConnectedEvent } from '../../../hooks/useAppConnectedEvent';
import { useAppConnectEvent } from '../../../hooks/useAppConnectEvent';
import { useDisconnectPlatformAppMutation } from '../../../queries/useDisconnectPlatformAppMutation';
import { usePlatformAppQuery } from '../../../queries/usePlatformAppQuery';
export const useMailchimp = () => {
    const { platformAppQuery: { data: mailchimpApp, refetch, isLoading }, } = usePlatformAppQuery(['apps.mailchimp']);
    const { open } = useModalContext();
    const appConnectEvent = useAppConnectEvent('mailchimp');
    const { disconnectPlatformAppMutation: disconnectMailchimpMutation } = useDisconnectPlatformAppMutation('apps.mailchimp');
    useAppConnectedEvent('mailchimp');
    const getStatus = () => {
        if (!mailchimpApp)
            return undefined;
        if (mailchimpApp.state === 'UNINSTALLED' || mailchimpApp.state === 'NEEDS_RECONNECT')
            return 'NOT_CONNECTED';
        if (mailchimpApp.state === 'INSTALLED')
            return 'CONNECTED';
    };
    const status = getStatus();
    const getConnectBar = () => {
        const connectBarBase = {
            logoSrc,
            description: status === 'CONNECTED' ? 'Connected to Mailchimp' : 'Connect to Fourthwall on Mailchimp',
            disabled: false,
        };
        if (!status)
            return undefined;
        if (status === 'NOT_CONNECTED') {
            if (!mailchimpApp)
                return;
            const onConnect = () => {
                appConnectEvent.trigger();
                window.location.assign(routing.external.mailchimp.connect);
            };
            return {
                ...connectBarBase,
                onConnect,
            };
        }
        if (status === 'CONNECTED') {
            const onDisconnect = () => {
                open(ConfirmModal, {
                    title: 'Are you sure you want to disconnect from Mailchimp?',
                    confirmLabel: 'Yes, disconnect',
                    confirmAppearance: 'destructive',
                    onConfirm: () => {
                        const toastId = 'disconnectMailchimpMutation';
                        Toasts.notify('Disconnecting from Mailchimp...', {
                            toastId,
                            type: 'info',
                            autoClose: false,
                        });
                        disconnectMailchimpMutation.mutate(undefined, {
                            onSuccess: () => {
                                refetch();
                                Toasts.notify('Disconnected from Mailchimp successfully.', { type: 'success' });
                                Toasts.dismiss(toastId);
                            },
                        });
                    },
                });
            };
            return {
                ...connectBarBase,
                disabled: disconnectMailchimpMutation.isLoading,
                onDisconnect,
            };
        }
    };
    return {
        connectBar: getConnectBar(),
        hmac: mailchimpApp?.hmac && mailchimpApp?.hmacTimestamp
            ? {
                signature: mailchimpApp.hmac,
                timestamp: mailchimpApp.hmacTimestamp,
            }
            : undefined,
        status,
        isLoading,
    };
};
